import type { FaqItem } from '../types/content'

export const faq: FaqItem[] = [
  {
    id: 'age',
    question: 'À quel âge peut-on commencer ?',
    answer:
      'La formation est ouverte dès 15 ans en élève pilote, avec autorisation parentale. Le brevet est délivré à partir de 16 ans. Il n’y a pas d’âge maximum.',
  },
  {
    id: 'medical',
    question: 'Faut-il un certificat médical ?',
    answer:
      'Aucune visite médicale n’est imposée pour piloter en ULM. Le pilote reste responsable de son aptitude à voler et une attestation de non contre-indication est demandée à l’inscription.',
  },
  {
    id: 'prix',
    question: 'Combien coûte une formation complète ?',
    answer:
      'Comptez 2 500 à 6 000 € selon la classe choisie et le nombre d’heures nécessaires. Le paramoteur reste l’entrée la plus économique, le multiaxe la plus polyvalente.',
  },
  {
    id: 'temps',
    question: 'Combien de temps pour être breveté ?',
    answer:
      'En moyenne 15 à 30 heures de vol, réparties sur quelques mois. Aucun volume horaire minimum n’est imposé : c’est l’instructeur qui valide votre autonomie.',
  },
  {
    id: 'ou',
    question: 'Où voler près de chez moi ?',
    answer:
      '1 200 bases ULM sont réparties sur tout le territoire, dont une majorité en terrain privé déclaré. L’annuaire fédéral permet de filtrer par département et par classe.',
  },
]
